export default "__VITE_ASSET__96yR17$K__"